/*
* @prop --component-select-label-color: color of select label
* @prop --component-select-hint-color: color of select hint
* @prop --component-select-text-color: color of text inside select
* @prop --component-select-border-color: color of select boarder
* @prop --component-select-icon-color: color of select icon
* @prop --component-select-disabled-color: color of select disabled
* @prop --component-select-success-color: color of select success
* @prop --component-select-error-color: color of select error
*/

// TODO: Remove inline choices styles

.ui-select {
  display: block;
  font-family: var(--skin-font-family-primary, $font-family-sans-serif);
  font-size: 16px;
  line-height: 24px;
  font-weight: $font-weight-normal;

  .select {
    &__label {
      font-size: inherit;
      line-height: inherit;
      font-weight: inherit;
      display: block;
      max-width: 100%;
      margin-top: -5px;
      margin-bottom: 12px;
      color: var(
        --component-select-label-color,
        var(--current-color-text, $ui-dark)
      );

      > .required {
        margin-left: 1px;
      }
    }

    &__hint {
      font-size: 12px;
      line-height: 18px;
      color: var(
        --component-select-hint-color,
        var(--current-color-text, $ui-dark)
      );
    }

    &__message {
      display: block;
      font-size: 15px;
      line-height: 20px;
      font-weight: $font-weight-bold;
      padding-top: 7px;
    }

    &--disabled {
      .select {
        &__label {
          color: var(--component-select-disabled-color, $ui-grey-plus-1);
        }

        .choices__input {
          color: var(--component-select-disabled-color, $ui-grey-plus-1);
        }
      }
    }

    &--error {
      .select {
        &__label {
          color: var(--component-select-error-color, $ui-red);
        }

        &__message {
          color: var(--component-select-error-color, $ui-red);
        }
      }

      .choices__inner {
        color: var(--component-select-error-color, $ui-red);
      }
    }

    &--success {
      .select {
        &__label {
          color: var(--component-select-success-color, $ui-green);
        }

        &__message {
          color: var(--component-select-success-color, $ui-green);
        }
      }

      .choices__inner {
        color: var(--component-select-success-color, $ui-green);
      }
    }

    &--checkbox {
      .choices {
        &::after {
          font-family: UI-IconFont, sans-serif;
          content: '\e639';
          line-height: 1;
          font-weight: $font-weight-normal;
          -webkit-font-smoothing: antialiased;
          font-size: 24px;
          position: absolute;
          top: 50%;
          right: 15px;
          margin-top: -10px;
          color: var(
            --component-select-icon-color,
            var(--skin-color-primary, $ui-blue)
          );
          pointer-events: none;
        }

        &.is-open::after {
          content: '\e636';
          margin-top: -12px;
        }

        &[data-type*='select-multiple'] {
          .choices__inner {
            cursor: pointer;
          }
        }

        &__inner {
          padding-bottom: 7.5px;

          .choices__list {
            display: none;
          }

          .choices__input {
            /* stylelint-disable declaration-no-important */
            width: 100% !important;
            margin: 0;
            padding: 4px 43.5px 4px 4px;
            line-height: 24px;
            text-align: left;
            color: inherit;
            cursor: pointer;
          }
        }

        &__list {
          &--dropdown {
            .choices__item {
              display: flex;
              align-items: center;
              min-height: 44px;
            }
          }
        }

        .ui-input {
          height: 16px;
          padding-right: 24px;
        }

        .ui-fund-riskclass {
          display: contents;
        }
      }

      &.select--disabled {
        .choices {
          &[data-type*='select-multiple'] {
            .choices__inner {
              color: var(--component-select-disabled-color, $ui-grey-plus-1);
              cursor: not-allowed;
            }
          }
        }
      }
    }
  }

  // dropdown styles for choices.js markup$choices-selector: 'choices' !default;
  $choices-selector: 'choices' !default;
  $choices-font-size-lg: 16px !default;
  $choices-font-size-md: 16px !default;
  $choices-font-size-sm: 16px !default;
  $choices-border-radius: 4px !default;
  $choices-border-radius-item: 4px !default;
  $choices-bg-color: $ui-white !default;
  $choices-bg-color-disabled: $ui-grey-plus-1 !default;
  $choices-bg-color-dropdown: $ui-white !default;
  $choices-text-color: $ui-dark !default;
  $choices-keyline-color: var(
    --component-select-border-color,
    $input-border-color
  ) !default;
  $choices-primary-color: var(--skin-color-primary, $ui-blue) !default;
  $choices-primary-shade: var(
    --skin-color-primary-shade,
    $ui-blue-plus-2
  ) !default;
  $choices-disabled-color: var(
    --component-select-disabled-color,
    $ui-grey-plus-1
  ) !default;
  $choices-highlight-color: $choices-primary-color !default;
  $choices-button-dimension: 8px !default;
  $choices-button-offset: 8px !default;
  $choices-icon-cross: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjEiIGhlaWdodD0iMjEiIHZpZXdCb3g9IjAgMCAyMSAyMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSIjRkZGIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxwYXRoIGQ9Ik0yLjU5Mi4wNDRsMTguMzY0IDE4LjM2NC0yLjU0OCAyLjU0OEwuMDQ0IDIuNTkyeiIvPjxwYXRoIGQ9Ik0wIDE4LjM2NEwxOC4zNjQgMGwyLjU0OCAyLjU0OEwyLjU0OCAyMC45MTJ6Ii8+PC9nPjwvc3ZnPg==') !default;
  $choices-icon-cross-inverse: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjEiIGhlaWdodD0iMjEiIHZpZXdCb3g9IjAgMCAyMSAyMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSIjMDAwIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxwYXRoIGQ9Ik0yLjU5Mi4wNDRsMTguMzY0IDE4LjM2NC0yLjU0OCAyLjU0OEwuMDQ0IDIuNTkyeiIvPjxwYXRoIGQ9Ik0wIDE4LjM2NEwxOC4zNjQgMGwyLjU0OCAyLjU0OEwyLjU0OCAyMC45MTJ6Ii8+PC9nPjwvc3ZnPg==') !default;
  $choices-z-index: 1;

  .#{$choices-selector} {
    position: relative;
    font-size: $choices-font-size-lg;
    color: var(--component-select-text-color, $ui-dark);

    &:focus {
      outline: none;
    }

    &:last-child {
      margin-bottom: 0;
    }

    &.is-open {
      overflow: initial;
    }

    &.is-disabled {
      .#{$choices-selector}__inner,
      .#{$choices-selector}__input {
        border-color: $choices-bg-color-disabled;
        cursor: not-allowed;
        user-select: none;
      }

      .#{$choices-selector}__item {
        cursor: not-allowed;
        color: $choices-bg-color-disabled;
      }

      &::after {
        color: $choices-bg-color-disabled !important;
      }
    }

    &.is-focused {
      .choices__inner {
        border-color: var(
          --component-select-border-color,
          var(--skin-color-primary, $ui-blue)
        ) !important;
        box-shadow: 0 1px 3px rgb(0 0 0 / 10%);
      }
    }

    [hidden] {
      display: none !important;
    }
  }

  .#{$choices-selector}[data-type|='select'] {
    cursor: pointer;

    .#{$choices-selector}__inner {
      padding-bottom: 7.5px;
    }

    .#{$choices-selector}__input {
      display: block;
      width: 100%;
      padding: 10px;
      background-color: #fff;
      margin: 0;

      &[type^='search'] {
        display: none;
      }
    }

    &.is-open {
      input[type^='search'] {
        display: block;
      }
    }

    .#{$choices-selector}__button {
      background-image: $choices-icon-cross-inverse;
      padding: 0;
      background-size: 8px;
      position: absolute;
      top: 50%;
      right: 0;
      margin-top: -10px;
      margin-right: 25px;
      height: 20px;
      width: 20px;
      border-radius: 10em;
      opacity: 0.25;

      &:hover,
      &:focus {
        opacity: 1;
      }

      &:focus {
        box-shadow: 0 0 0 2px $choices-highlight-color;
      }
    }

    .#{$choices-selector}__item[data-value=''] .#{$choices-selector}__button {
      display: none;
    }

    &::after {
      font-family: UI-IconFont, sans-serif;
      content: '\e639';
      line-height: 1;
      font-weight: $font-weight-normal;
      -webkit-font-smoothing: antialiased;
      font-size: 24px;
      position: absolute;
      top: 50%;
      right: 15px;
      margin-top: -10px;
      color: var(
        --component-select-icon-color,
        var(--skin-color-primary, $ui-blue)
      );
      pointer-events: none;
    }

    &.is-open::after {
      content: '\e636';
      margin-top: -12px;
    }

    &[dir='rtl'] {
      &::after {
        left: 11.5px;
        right: auto;
      }

      .#{$choices-selector}__button {
        right: auto;
        left: 0;
        margin-left: 25px;
        margin-right: 0;
      }
    }
  }

  .#{$choices-selector}[data-type*='select-multiple'],
  .#{$choices-selector}[data-type*='text'] {
    .#{$choices-selector}__inner {
      cursor: text;
    }

    .#{$choices-selector}__button {
      position: relative;
      display: inline-block;
      margin: 0 (-$choices-button-offset / 2) 0 $choices-button-offset;
      margin-left: $choices-button-offset;
      padding-left: $choices-button-offset * 2;
      border-left: 1px solid $choices-primary-shade;
      background-image: $choices-icon-cross;
      background-size: $choices-button-dimension;
      width: $choices-button-dimension;
      line-height: 1;
      opacity: 0.75;
      border-radius: 0;

      &:hover,
      &:focus {
        opacity: 1;
      }
    }
  }

  .#{$choices-selector}__inner {
    display: inline-block;
    vertical-align: top;
    width: 100%;
    background-color: $choices-bg-color;
    padding: 7.5px 7.5px 3.75px;
    border: 1px solid $choices-keyline-color;
    border-radius: $choices-border-radius;
    font-size: $choices-font-size-md;
    min-height: 44px;
    overflow: hidden;
    position: relative;
    box-sizing: border-box;

    .is-focused &,
    .is-open & {
      border-color: $choices-keyline-color, 15;
    }

    .is-open & {
      border-radius: $choices-border-radius $choices-border-radius 0 0;
    }

    .is-flipped.is-open & {
      border-radius: 0 0 $choices-border-radius $choices-border-radius;
    }
  }

  .#{$choices-selector}__list {
    margin: 0;
    padding-left: 0;
    list-style: none;
    box-sizing: border-box;
  }

  .#{$choices-selector}__list--single {
    display: inline-block;
    padding: 4px 16px 4px 4px;
    width: 100%;

    [dir='rtl'] & {
      padding-right: 4px;
      padding-left: 16px;
    }

    .#{$choices-selector}__item {
      @media (min-width: 640px) {
        padding-right: 50px;
      }

      width: 100%;
    }
  }

  .#{$choices-selector}__list--multiple {
    display: inline;

    .#{$choices-selector}__item {
      display: inline-block;
      vertical-align: middle;
      border-radius: $choices-border-radius-item;
      padding: 4px 10px;
      font-size: $choices-font-size-sm;
      font-weight: 500;
      margin-right: 3.75px;
      margin-bottom: 3.75px;
      background-color: $choices-primary-color;
      border: 1px solid $choices-primary-shade;
      color: #fff;
      word-break: break-all;
      box-sizing: border-box;

      &[data-deletable] {
        padding-right: 5px;
      }

      [dir='rtl'] & {
        margin-right: 0;
        margin-left: 3.75px;
      }

      &.is-highlighted {
        background-color: $choices-primary-shade;
        border: 1px solid $choices-primary-shade;
      }

      .is-disabled & {
        background-color: $choices-disabled-color;
        border: 1px solid $choices-disabled-color;
      }
    }
  }

  .#{$choices-selector}__list--dropdown {
    visibility: hidden;
    z-index: $choices-z-index;
    position: absolute;
    width: 100%;
    background-color: $choices-bg-color-dropdown;
    border: 1px solid $choices-keyline-color;
    top: 100%;
    margin-top: -5px;
    padding-top: 4px;
    border-bottom-left-radius: $choices-border-radius;
    border-bottom-right-radius: $choices-border-radius;
    word-break: break-all;
    will-change: visibility;

    &::after {
      content: '';
      position: absolute;
      top: -44px;
      left: -1px;
      height: calc(100% + 45px);
      width: calc(100% + 2px);
      box-shadow: 0 2px 3px #333;
      border-radius: 4px;
      pointer-events: none;
    }

    &.is-active {
      visibility: visible;
      border-color: var(
        --component-select-border-color,
        var(--skin-color-primary, $ui-blue)
      ) !important;
    }

    .is-open & {
      border-color: $choices-keyline-color;
    }

    .is-flipped & {
      top: auto;
      bottom: 100%;
      margin-top: 0;
      margin-bottom: -1px;
      border-radius: 0.25rem 0.25rem 0 0;
    }

    .#{$choices-selector}__list {
      position: relative;
      max-height: 300px;
      overflow: auto;
      -webkit-overflow-scrolling: touch;
      will-change: scroll-position;
      padding: 5px 0;
    }

    .#{$choices-selector}__item {
      position: relative;
      padding: 10px;
      font-size: $choices-font-size-md;
      margin: 0 4px;

      [dir='rtl'] & {
        text-align: right;
      }
    }

    .#{$choices-selector}__item--selectable {
      @media (min-width: 640px) {
        &::after {
          content: attr(data-select-text);
          font-size: $choices-font-size-sm;
          opacity: 0;
          position: absolute;
          right: 10px;
          top: 50%;
          transform: translateY(-50%);
        }

        [dir='rtl'] & {
          text-align: right;
          padding-left: 100px;
          padding-right: 10px;

          &::after {
            right: auto;
            left: 10px;
          }
        }
      }

      &.is-highlighted {
        /* stylelint-disable-next-line scss/no-global-function-names, function-no-unknown */
        background-color: mix(#000, #fff, 5%);

        &::after {
          opacity: 0.5;
        }
      }
    }
  }

  .#{$choices-selector}__item {
    cursor: default;
  }

  .#{$choices-selector}__item--selectable {
    cursor: pointer;
  }

  .#{$choices-selector}__item--disabled {
    cursor: not-allowed;
    user-select: none;
    opacity: 0.5;
  }

  .#{$choices-selector}__heading {
    font-weight: 600;
    font-size: $choices-font-size-sm;
    padding: 10px;
    border-bottom: 1px solid $choices-keyline-color;
    /* stylelint-disable-next-line scss/no-global-function-names, function-no-unknown */
    color: lighten(#333, 30%);
  }

  .#{$choices-selector}__button {
    text-indent: -9999px;
    appearance: none;
    border: 0;
    background-color: transparent;
    background-repeat: no-repeat;
    background-position: center;
    cursor: pointer;

    &:focus {
      outline: none;
    }
  }

  .#{$choices-selector}__input {
    display: inline-block;
    vertical-align: baseline;
    background-color: $choices-bg-color;
    font-size: $choices-font-size-md;
    margin-bottom: 5px;
    border: 0;
    border-radius: 0;
    max-width: 100%;
    padding: 4px 0 4px 2px;

    &:focus {
      outline: 0;
    }

    [dir='rtl'] & {
      padding-right: 2px;
      padding-left: 0;
    }
  }

  .#{$choices-selector}__placeholder {
    opacity: 0.5;
  }
}
